// components/Reusablesteps/onboarding/onboardingTokens.js
// Shared tokens, icons, and micro-components used by all 4 onboarding screens.

import React, { useState } from "react";
import onbStyles from "./Onboarding.module.css";

/* ─────────────────────────────────────────────────────────────────
   DESIGN TOKENS
───────────────────────────────────────────────────────────────── */
export const T = {
  primary:     "#4B2DA0",
  primaryDark: "#3a2080",
  primaryBg:   "var(--ava-bg-primary-light)",
  border:      "#c6d0e8",
  muted:       "#9aa5c4",
  text:        "#1a2e6c",
  sub:         "#4b5a8a",
  green:       "#2ecc71",
  error:       "#e53e3e",
};

/* ─────────────────────────────────────────────────────────────────
   ICONS
───────────────────────────────────────────────────────────────── */
export const ArrowRight = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none"
    stroke="#fff" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const LockIcon = () => (
  <svg width={14} height={14} viewBox="0 0 24 24" fill="none"
    stroke={T.primary} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <rect x={3} y={11} width={18} height={11} rx={2} />
    <path d="M7 11V7a5 5 0 0110 0v4" />
  </svg>
);

/* ─────────────────────────────────────────────────────────────────
   SHARED MICRO-COMPONENTS
───────────────────────────────────────────────────────────────── */

/** Secure footer line */
export const SecureLine = () => (
  <div className={onbStyles.secureInfo}>
    <LockIcon />
    <span>Your information is private and secure</span>
  </div>
);

/** Primary CTA button — full-width, disabled state handled */
export const PrimaryBtn = ({ label, onClick, disabled, icon }) => (
  <button
    className={`${onbStyles.primaryBtn} ${disabled ? onbStyles.primaryBtnDisabled : ""}`}
    onClick={onClick}
    disabled={disabled}
    type="button"
  >
    {label}
    {icon && <span className={onbStyles.btnIcon}>{icon}</span>}
  </button>
);

/** Progress dots (used by Mobile + OTP screens) */
export const ProgressDots = ({ current, total }) => (
  <div className={onbStyles.progressDots}>
    {Array.from({ length: total }).map((_, i) => (
      <div
        key={i}
        className={onbStyles.dot}
        style={{
          width:      i === current ? 20 : 8,
          background: i < current ? T.green
                    : i === current ? T.primary
                    : T.border,
        }}
      />
    ))}
  </div>
);
